import React, { Fragment, useState, useEffect } from 'react';
import DoctorFeesTable from './DoctorFeesTable';
import DoctorFeesTableActions from './DoctorFeesTableActions';
import Spinner from 'react-bootstrap/Spinner';
import { Row, Col } from 'reactstrap';
import { formatNumber } from '../../Utils/Money';

const DoctorFees = ({ }) => {

    const [loading, setLoading] = useState(false);
    const [doctorFees, setDoctorFees] = useState([]);


    const [subTotalFees, setSubTotalFees] = useState(0);
    const [retentions, setRetentions] = useState(0);
    const [totalFees, setTotalFees] = useState(0);

    useEffect(() => {
        honorariosEfectuados();
    }, []);

    const honorariosEfectuados = async () => {
        setLoading(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'honorarios-efectuados/consultar-por-usuario', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                id_usuario: JSON.parse(sessionStorage.getItem('usuario')).id_usuario
            })
        }).then((response) => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el servidor");
            }
        }).then((data) => {
            console.log("doctorFees", data);
            setDoctorFees(data);
            calculateAll(data).then((resData) => {
                setLoading(false);
            }).catch((error) => {
                console.log(error);
                setDoctorFees([]);
                setLoading(false);
            })
        }).catch((error) => {
            console.log(error);
            setDoctorFees([]);
            setLoading(false);
        });
    }

    const DataFeesDoctor = () => {
        return (<DoctorFeesTable reactTableData={doctorFees} ReactTableActions={DoctorFeesTableActions} />);
    }

    const calculateAll = async (data) => {
        let subtotalData = 0;
        let retencionData = 0;
        let totalData = 0;

        for (let i = 0; i < data.length; i++) {
            subtotalData = parseInt(subtotalData) + parseInt(data[i].subtotal);
            retencionData = parseInt(retencionData) + parseInt(data[i].retencion);
            totalData = parseInt(totalData) + parseInt(data[i].total);
        }
        
        setSubTotalFees(subtotalData);
        setRetentions(retencionData);
        setTotalFees(totalData);
    }

    return (
        <Fragment>

            <Row>
                <Col md={4}>
                    <div className="text-center">
                        <h4>Subtotal Recibido</h4>
                        <h3 style={{ color: '#0084CF' }}>$ {formatNumber(subTotalFees)}</h3>
                    </div>
                </Col>
                <Col md={4}>
                    <div className="text-center">
                        <h4>Total Retenciones</h4>
                        <h3 style={{ color: '#0084CF' }}>$ {formatNumber(retentions)}</h3>
                    </div>
                </Col>
                <Col md={4}>
                    <div className="text-center">
                        <h4>Total Recibido</h4>
                        <h3 style={{ color: '#0084CF' }}>$ {formatNumber(totalFees)}</h3>
                    </div>
                </Col>
            </Row>


            <br />

            {loading ? <div className="text-center">
                <Spinner animation="border" variant="success" />
            </div> : <DataFeesDoctor />}
        </Fragment>);
}

export default DoctorFees;